export const TeXFileType = Object.freeze({
    FOLDER: 0,
    TEX: 1,
    PROJECT: 2
});